<template>
	<div id="app">
		<NavM
			v-if="showAppChrome"
			:is-show-back="isLendingSecondaryPage"
			@back="handleNavBack"
		/>
		<!-- 顶栏/底栏让位只加在这层。新页面不要再写 --ld-nav-space / --ld-tabbar-space -->
		<div class="ld-app-body">
			<router-view />
		</div>
		<MobileTabBar v-if="showAppChrome" />
		<NoticeDialog
			:visible="noticeVisible"
			:title="noticeTitle"
			:content="noticeContent"
			@close="closeNotice"
		/>
		<CustomerChat />
	</div>
</template>
<script>
import request from "@/utils/request";
import NavM from "@/components/nav_m.vue";
import MobileTabBar from "@/components/MobileTabBar.vue";
import {
	mapState
} from "vuex";
import store from "./store";
import NoticeDialog from "./components/NoticeDialog.vue";
import CustomerChat from "@/components/CustomerChat/index.vue";
import { startIdlePrefetch } from "@/router/asyncViews";
import { startWalletAddressGuard } from "@/utils/walletAddressGuard";
import { applyBrowserInsets, isTrustWalletBrowser } from "@/utils/browserInsets";
export default {
	data() {
		return {
			windowWidth: document.body.clientWidth,
			noticeVisible: false,
			noticeTitle: '',
			noticeContent: '',
			noticeShown: false
		};
	},
	components: {
		NavM,
		MobileTabBar,
		NoticeDialog,
		CustomerChat
	},
	mounted() {
		applyBrowserInsets();
		store.commit("SetInnerWidth", document.body.clientWidth);
		store.commit("SET_IS_PC", this.isMobileDevice());
		window.onresize = () => {
			return (() => {
				this.windowWidth = document.documentElement.clientWidth; // 宽
				store.commit("SetInnerWidth", this.windowWidth);
				store.commit("SET_IS_PC", this.isMobileDevice());
			})();
		};
		// 在页面加载时和窗口大小变化时调用设置字体大小的函数
		window.addEventListener('DOMContentLoaded', this.setRootFontSize);
		window.addEventListener('resize', this.setRootFontSize);
		// 设置默认语言
		let lang = localStorage.getItem("lang") || this.$store.state.currentLanguage;
		this.$store.commit("SET_LANG", lang);
		this.$store.dispatch("listContents", lang == 'zh' ? 1 : 2).then((res) => {
			console.log(res, "language");
		});
		const storedUser = this.$store.state.userInfo
		const storedVirtual = localStorage.getItem("virtualStatus") || 1
		this.$store.commit("changeVirtual", storedUser && storedUser.userType != null
			? (Number(storedUser.userType) === 2 ? 2 : 1)
			: storedVirtual);
		this.connectMarketWsIfLoggedIn();
		// 🎯 延迟检查公告，解决Trust钱包等环境的时序问题
		this.initNoticeCheck();

		// 借贷池主题：跟随系统深浅色
		this.$store.commit('RESOLVE_THEME');
		this.bindThemeMediaListener();

		// 判断当前是手机还是pc
		if (localStorage.getItem('isLogin') === 'true' && localStorage.getItem('token')) {
			this.$store.dispatch('FETCH_WALLET_AUTH_STATUS')
			this.$store.dispatch('START_UNREAD_POLL')
		}
		startWalletAddressGuard(this.$store)
		this.tryIdlePrefetch()
	},
	beforeDestroy() {
		this.unbindThemeMediaListener();
		if (typeof document !== 'undefined') {
			document.documentElement.classList.remove('has-ld-nav');
		}
	},
	watch: {
		// 监听页面宽度
		windowWidth(val) {
			console.log(val, "width");
			// store.commit('SetInnerWidth', val)
		},

		// 🎯 监听路由变化（移除公告检查，避免切换页面时重复显示）
		'$route'(to, from) {
			// 路由切换时不再检查公告，只在初次登录或刷新时检查
		},

		// 🎯 监听登录状态变化，登出时重置公告显示标记
		'$store.state.isLogin'(newVal, oldVal) {
			if (!newVal && oldVal) {
				this.noticeShown = false;
				this.$store.dispatch('CLOSE_MARKET_WS');
				this.$store.dispatch('STOP_UNREAD_POLL');
			} else if (newVal && !oldVal) {
				this.connectMarketWsIfLoggedIn();
				this.$store.dispatch('START_UNREAD_POLL');
			}
		},

		'$route.name'() {
			this.tryIdlePrefetch()
		},

		showAppChrome: {
			immediate: true,
			handler(on) {
				if (typeof document === 'undefined') return
				document.documentElement.classList.toggle('has-ld-nav', !!on)
			}
		},
	},
	computed: {
		...mapState([
			"isPc",
			"lginWhiteList",
		]),
		currentRouteName() {
			return this.$route.name;
		},
		is3d() {
			return this.lginWhiteList.indexOf(this.currentRouteName) > -1;
		},
		isPassPage() {
			const path = (this.$route && this.$route.path) || '';
			const name = this.currentRouteName;
			return path.indexOf('/pass') === 0 || name === 'empty';
		},
		isLendingSecondaryPage() {
			return !!(this.$route.meta && this.$route.meta.lendingNavBack);
		},
		showAppChrome() {
			return !this.is3d && !this.isPassPage;
		},
	},
	methods: {
		connectMarketWsIfLoggedIn() {
			const isLogin = localStorage.getItem('isLogin') === 'true';
			const hasToken = !!localStorage.getItem('token');
			if (!isLogin || !hasToken) {
				return;
			}
			this.$store.dispatch('INIT_MARKET_WS').catch(() => {});
		},
		tryIdlePrefetch() {
			const name = this.currentRouteName
			if (name === 'empty') return
			startIdlePrefetch()
		},
		handleNavBack() {
			if (window.history.length > 1) {
				this.$router.back();
			} else if (this.$route.name === 'lendingPoolDetail') {
				this.$router.push({ name: 'lendingPools' }).catch(() => {});
			} else {
				this.$router.push({ name: 'home' }).catch(() => {});
			}
		},
		bindThemeMediaListener() {
			if (!window.matchMedia) return;
			this._themeMedia = window.matchMedia('(prefers-color-scheme: dark)');
			this._onThemeMediaChange = () => {
				if (this.$store.state.themeMode === 'auto') {
					this.$store.commit('RESOLVE_THEME');
				}
			};
			if (this._themeMedia.addEventListener) {
				this._themeMedia.addEventListener('change', this._onThemeMediaChange);
			} else if (this._themeMedia.addListener) {
				this._themeMedia.addListener(this._onThemeMediaChange);
			}
		},
		unbindThemeMediaListener() {
			if (!this._themeMedia || !this._onThemeMediaChange) return;
			if (this._themeMedia.removeEventListener) {
				this._themeMedia.removeEventListener('change', this._onThemeMediaChange);
			} else if (this._themeMedia.removeListener) {
				this._themeMedia.removeListener(this._onThemeMediaChange);
			}
		},

		isMobileDevice() {
			var userAgent = navigator.userAgent;
			return !(/Android|iPhone|iPad|iPod/i.test(userAgent));
		},

		setRootFontSize() {
			console.log(111);
			let baseWidth = 1920;
			if (window.innerWidth > 1000) {
				baseWidth = 1920;
			} else {
				baseWidth = 750;
			}
			const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			let scale = 1;
			if (baseWidth == 750) {
				scale = (screenWidth / baseWidth) + .37;
			} else {
				// scale=(screenWidth/baseWidth) + .2;
				scale = (screenWidth / baseWidth) + 1;
			}
			console.log(scale, 'scale');
			const maxRemSize = 100;
			const rootFontSize = Math.min(maxRemSize, 100 * scale);
			console.log(rootFontSize, 'rootFontSize');
			document.documentElement.style.fontSize = rootFontSize + 'px';
		},

		// 🎯 初始化公告检查（解决Trust钱包等环境的时序问题）
		initNoticeCheck() {
			// 🎯 检测是否在Trust钱包环境
			const isTrustWallet = this.isTrustWallet();
			console.log('🎯 [用户公告] 开始初始化公告检查', {
				isTrustWallet,
				userAgent: navigator.userAgent
			});

			// 立即检查一次
			this.performNoticeCheck();

			// 🎯 为Trust钱包等环境添加延迟检查
			const delays = isTrustWallet ? [500, 1500, 3000] : [500, 1500];

			delays.forEach((delay, index) => {
				setTimeout(() => {
					console.log(`🎯 [用户公告] 延迟检查公告（${delay}ms）`);
					this.performNoticeCheck();
				}, delay);
			});
		},

		// 🎯 检测是否在Trust钱包环境
		isTrustWallet() {
			return isTrustWalletBrowser();
		},

		// 🎯 执行公告检查
		performNoticeCheck() {
			// 如果已经显示过公告，跳过
			if (this.noticeShown) {
				console.log('🎯 [用户公告] 公告已显示过，跳过延迟检查');
				return;
			}

			const isLogin = localStorage.getItem("isLogin") === 'true';
			const hasToken = localStorage.getItem("token");

			console.log('🎯 [用户公告] 执行公告检查', {
				isLogin,
				hasToken: !!hasToken,
				storeUserInfo: !!this.$store.state.userInfo
			});

			if (isLogin && hasToken) {
				// 主要检查：通过API获取用户信息
				this.$store.dispatch("GET_USER_INFO").then((res) => {
					console.log('🎯 [用户公告] API获取用户信息成功:', res);
					const userInfo = res.result || res;
					this.checkUserNotice(userInfo);
				}).catch((err) => {
					console.error("🎯 [用户公告] 获取用户信息失败:", err);
					// 如果API失败，尝试从store获取
					this.checkUserInfoFromStore();
				});
			} else {
				// 备用检查：从store中获取用户信息
				this.checkUserInfoFromStore();
			}
		},

		// 🎯 从store检查用户信息
		checkUserInfoFromStore() {
			if (this.$store.state.userInfo && Object.keys(this.$store.state.userInfo).length > 0) {
				console.log('🎯 [用户公告] 从store中检查公告');
				this.checkUserNotice(this.$store.state.userInfo);
			} else {
				console.log('🎯 [用户公告] store中无用户信息');
			}
		},

		// 🎯 检查用户公告
		checkUserNotice(userInfo) {
			console.log('🎯 [用户公告] 开始检查公告', {
				noticeShown: this.noticeShown,
				userInfo: userInfo,
				hasNoticeTitle: !!(userInfo && userInfo.noticeTitle),
				hasNoticeContent: !!(userInfo && userInfo.noticeContent)
			});

			// 如果公告已经显示过，不再重复显示
			if (this.noticeShown) {
				console.log('🎯 [用户公告] 公告已显示过，跳过');
				return;
			}

			if (userInfo && userInfo.noticeTitle && userInfo.noticeContent) {
				this.noticeTitle = userInfo.noticeTitle;
				this.noticeContent = userInfo.noticeContent;
				this.noticeVisible = true;
				this.noticeShown = true; // 🎯 标记公告已显示
				console.log('🎯 [用户公告] 显示公告:', userInfo.noticeTitle);
			} else {
				console.log('🎯 [用户公告] 无公告需要显示');
			}
		},

		// 🎯 关闭公告弹框
		closeNotice() {
			this.noticeVisible = false;
			this.noticeTitle = '';
			this.noticeContent = '';
			// 🎯 注意：不重置noticeShown标记，确保本次会话中不再重复显示
			console.log('🎯 [用户公告] 公告已关闭');
		}
	},
};
</script>
<style>
@import "reset.css";
@import "styles/ios-safe-area.css";

/* @media screen and (min-width: 1000px) {
  #app {
    width: 1440px;
    margin: 0 auto;
  }
} */
@font-face {
	font-family: 'Mabry Pro';
	src: url('./assets/fonts/mabry-regular-pro.ttf');
	font-weight: normal;
	font-style: normal;
	font-display: swap;
}

body {
	font-size: 0.16rem;
}

img,
video {
	max-width: 100%;
	height: auto;
}

.button {
	cursor: pointer;
	padding: 0 .36rem;
	height: 100%;
	border-radius: .2rem;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 700;
	font-size: .2rem;
	color: #000;
	-webkit-tap-highlight-color: transparent
}

.button .icon {
	margin-right: .12rem;
	width: .24rem;
	height: .24rem
}

#app {
	margin: 0 auto;
	width: 100%;
	max-width: 14.4rem;
	font-family: Mabry Pro;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	font-size: .16rem;
	-webkit-tap-highlight-color: transparent;
	background-color: var(--ld-bg, #ffffff);
}

.input_fields .el-input .el-input__wrapper {
	box-shadow: none;
	background: none;
}

.button.round {
	border-radius: .32rem
}

.button.normal {
	background: #e8e8e8
}

.button.yellow {
	background: linear-gradient(180deg, #ffdc61, #ffbc49)
}

.button.black {
	background: #000;
	color: #fff
}

.button.line {
	background: #fff;
	border: .02rem solid #000;
	box-sizing: border-box
}

.button.disabled {
	background: #dfdfdf;
	color: #8a8a8a
}

/* 🎯 完全移除按钮点击时的视觉变化 按钮样式问题  浅蓝色 阴影 */
.button:active,
button:active,
.tab:active,
.cur:active,
[role="button"]:active,
div[onclick]:active,
.btn:active,
.btn2:active,
.buttons:active,
span[onclick]:active {
	outline: none !important;
	box-shadow: none !important;
	border-radius: inherit !important;
	background: inherit !important;
	transform: none !important;
	transition: none !important;
	-webkit-tap-highlight-color: transparent !important;
	-webkit-touch-callout: none !important;
	-webkit-user-select: none !important;
	-khtml-user-select: none !important;
	-moz-user-select: none !important;
	-ms-user-select: none !important;
	user-select: none !important;
}

</style>